<template>
  <div :class="classes">
    <div v-if="showHeader" class="rts-Wrapper_Header">
      <slot name="header-prepend" />

      <AppTitle :level="4" class="rts-HeaderTitle" disable-margin>
        {{ $t(ELEMENT_PROGRESS_ADJUSTMENT_TABS.SETUP.label) }}
      </AppTitle>
    </div>
    <div class="rts-Wrapper_Type">
      <LockMessage v-if="showLockMessage" class="rts-Wrapper_Message">
        <div>
          <slot name="lock-message">
            {{ $t('update.keyResult.result_type_lock_message') }}
            <slot name="lock-message-description" />
          </slot>
        </div>
      </LockMessage>
      <slot v-else name="left-side" />
    </div>
    <div class="rts-Container">
      <div class="rts-Container_Content">
        <div class="rts-Options_Wrapper">
          <slot name="right-side" />
        </div>
        <slot name="append-after-right-side" />
      </div>

      <slot name="footer" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { TYPES } from '@/utils/components-configurations/result-type-settings'
import { ELEMENT_PROGRESS_ADJUSTMENT_TABS } from '@/utils/element-types'
import { includesValue } from '@/utils/prop-validators'

import { FIELDS_COUNT } from '@/components/form/key-result/result-type-settings'
import LockMessage from '@/components/form/LockMessage'
import AppTitle from '@/components/ui/AppTitle/AppTitle'

defineOptions({
  name: 'ResultTypeSettings'
})

const props = defineProps({
  fieldsCount: {
    type: Number,
    default: FIELDS_COUNT.ONE_FIELD,
    validator: v => Number.isInteger(v) && includesValue(v, FIELDS_COUNT)
  },

  showLockMessage: {
    type: Boolean
  },

  type: {
    type: String,
    default: TYPES.DEFAULT
  },

  showHeader: {
    type: Boolean
  }
})

const classes = computed(() => {
  return {
    'rts-Wrapper': true,
    [`rts-Wrapper-${props.type}`]: true
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/result-type-settings';

.rts-Wrapper {
  border-radius: $border-radius-md-next;
  box-shadow: inset 0 0 0 2px $grey-3-next, 0 6px 8px rgba($grey-2-next, 0.5),
    0 2px 2px $grey-2-next;
  position: relative;
  overflow: hidden;

  --padding-block: 20px;

  &-centered {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.rts-Wrapper_Message {
  margin: 0 auto;
  padding: 4px 0;
}

.rts-Wrapper_Header {
  width: 100%;
  padding: 20px 20px 18px;
  min-height: 64px;
  overflow: hidden;
  box-shadow: inset 0 -2px 0 $grey-3-next;
  display: flex;
  align-items: center;
  gap: 4px;
}

.rts-Wrapper_Type {
  &:not(&:empty) {
    padding: 16px 20px;
  }
}

.rts-Options_Wrapper {
  border-radius: inherit;
  display: grid;
  grid-template-columns: repeat(v-bind(fieldsCount), 1fr);
  gap: inherit;
  width: 100%;

  .rts-Wrapper-centered & {
    text-align: left;
  }
}

.rts-Container_Content {
  display: flex;
  gap: $fields-gap;

  .rts-Wrapper-centered & {
    max-width: $fullscreen-result-type-settings-max-width;
    margin-inline: auto;
  }
}

.rts-Container {
  padding: var(--rts-container-padding, (18px var(--padding-block) 20px));
  width: 100%;
  background-color: $grey-3-next;
}
</style>
